<template>
  <section>
    <article class="w-2/3 flex flex-row justify-between items-start mt-5">
      <!-- Left Column -->
  
      <table aria-label="leftHeaders" aria-hidden="true">
        <tr v-for="(header, index) in leftHeaders" :key="index">
          <td class="font-semibold pt-1">
            {{ $t(header.label?.getTranslationKey()) }}
          </td>
          <td class="pt-1">
            <span class="font-semibold px-1"> :</span>
            <span v-if="header.key === 'sort_code'">
              {{ getSortSwiftCode }}
            </span>
            <span v-else>
              {{ formatValue(tableObject[header.key], header.type) }}
            </span>
          </td>
        </tr>
      </table>

      <!-- Right Column -->
      <table aria-label="rightHeaders" aria-hidden="true">
        <tr v-for="(header, index) in rightHeaders" :key="index">
          <td class="font-semibold pt-1">
            {{ $t(header.label?.getTranslationKey()) }}
          </td>
          <td class="pt-1">
            <span class="font-semibold px-1"> :</span>
            <span v-if="header.key.includes('sort_code')">
              {{ getSortSwiftCode }}
            </span>
            <span v-else>
              {{ formatValue(tableObject[header.key], header.type) }}
            </span>
          </td>
        </tr>
      </table>
    </article>
  </section>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "BaseBankDetails",
  props: {
    tableObject: {
      type: Object,
      default: () => ({}),
    },
    headers: {
      type: Array,
      default: () => [
        { key: "account_title", label: "Account Holder", type: "text" },
        { key: "bank_address", label: "City of Bank", type: "text" },
        { key: "account_number", label: "Account Number", type: "text" },
        { key: "bank_name", label: "Bank Name", type: "text" },
        { key: "swift_code", label: "BIC/SWIFT", type: "text" },
        { key: "iban", label: "IBAN", type: "text" },
      ],
    },
  },
  computed: {
    leftHeaders() {
      // Get the first half of headers for the left column
      return this.headers?.slice(0, Math.ceil(this.headers.length / 2));
    },
    rightHeaders() {
      // Get the second half of headers for the right column
      return this.headers?.slice(Math.ceil(this.headers.length / 2));
    },
    getSortSwiftCode() {
      return this.tableObject?.mission__new_expert__sort_code
        ? `${this.tableObject.mission__new_expert__sort_code}/${this.tableObject.mission__new_expert__swift_code}`
        : "";
    },
  },
  methods: {
    formatValue(value, header) {
     
      switch (header.type) {
        case "date":
          return (value && value?.formattedDate()) || "N/A";
        case "currency":
          return (value && Number(value)?.getCurrencyFormat()) || "N/A";
        default:
          return value || "N/A";
      }
    },
  }
});
</script>


